import React from 'react';

import { Box } from '@mui/material';

import { FullscreenLoader } from 'src/components/common';
import { RevenueShareCard } from 'src/components/revenueShare';
import { useCurrentUserEmployer } from 'src/hooks/employer';
import { NotFoundErrorPage } from 'src/pages/not-found';
import { employerReceivesOwnRevenueShare } from 'src/utils/revenueShare';

export const EmployerWallet: React.FC = () => {
  const { employer, loading } = useCurrentUserEmployer();

  if (loading) {
    return <FullscreenLoader />;
  }

  if (!employer?.revenueShareSetting || !employerReceivesOwnRevenueShare(employer)) {
    return <NotFoundErrorPage />;
  }

  return (
    <Box width="50%">
      <RevenueShareCard company={employer} />
    </Box>
  );
};
